import Constants from 'expo-constants'
import { getLanguage } from '../../appBar/context/LocalizationContext'
const expoConfig = Constants.expoConfig || { slug: '' }
const slug = expoConfig.slug

export function getReprobatedText() {
    const { languageFile } = getLanguage()
    let text_reprobate = languageFile.reprobate
    if (slug === 'branca-one') text_reprobate = 'Rehacer'
    if (slug === 'salesbook-one') text_reprobate = 'REPASAR'
    return text_reprobate
}
